export const SITE_CONFIG = {
  name: 'Software Lab',
  tagline: 'Systems & Solutions',
  url: 'https://softwarelabbg.com',
  locale: 'en_US',
  language: 'en',
  defaultOgImage: '/brand/og-image.svg',
  defaultOgImageAlt: 'Software Lab - Systems & Solutions',
  email: 'contact@softwarelabbg.com',
  phone: '+359877517900',
  linkedIn: 'https://www.linkedin.com/company/software-lab-bg',
  address: {
    street: 'Doctor Yordan Yosifov 1a',
    city: 'Sofia',
    country: 'Bulgaria',
    countryCode: 'BG',
  },
  foundingYear: 2020,
} as const;

export function absoluteUrl(path = ''): string {
  if (!path || path === '/') return `${SITE_CONFIG.url}/`;
  const normalized = path.startsWith('/') ? path : `/${path}`;
  return `${SITE_CONFIG.url}${normalized}`;
}

export function absoluteAsset(path: string): string {
  return absoluteUrl(path.startsWith('/') ? path : `/${path}`);
}
